import { createSlice } from "@reduxjs/toolkit";
import { getSystemCampaignStatusAPI } from "../../services/getSystemCampaignStatus";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getSystemCampaignStatusSlice = createSlice({
  name: "getSystemCampaignStatus",
  initialState: data,
  reducers: {
    getSystemCampaignStatusInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getSystemCampaignStatusInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
    },
    getSystemCampaignStatusInfoFailure(state, action) {
      state.isLoading = false;
      state.data = null;
      state.error = action.payload;
    },
    getSystemCampaignStatusInfoReset(state) {
      state.isLoading = false;
      state.data = null;
      state.error = "";
      state.message = "";
    },
  },
});

export const getSystemCampaignStatusHandler = (payload) => async (dispatch) => {
  try {
    dispatch(getSystemCampaignStatusAction.getSystemCampaignStatusInfo());
    const response = await getSystemCampaignStatusAPI(payload);
    dispatch(getSystemCampaignStatusAction.getSystemCampaignStatusInfoSuccess(response));
  } catch (e) {
    const errorMessage = typeof e === "string" ? e : e?.message || "Something went wrong.";
    dispatch(getSystemCampaignStatusAction.getSystemCampaignStatusInfoFailure(errorMessage));
  }
};

export default getSystemCampaignStatusSlice.reducer;
export const getSystemCampaignStatusAction = getSystemCampaignStatusSlice.actions;
